import { useEffect } from "react";
import getDefaultVariantsState from "@/func/defaultVariants";

export const useDefaultProductData = ({
  productData,
  isSubscribe,
  selectedProduct,
  setVariants,
  setWarrantyState,
  handleChange,
}) => {
  useEffect(() => {
    if (!productData.products?.length) return;

    if (selectedProduct) {
      const match = productData.products.find((p) => p.amount === selectedProduct.amount);
      if (match) {
        // re-run; will recalc shipping/warranty based on current isSubscribe
        handleChange(match);
      }
      return;
    }

    const defaultProductIndex = productData.products.findIndex((item) => item.best_seller === true);

    const enableVariants = productData?.enable_color_variants || productData?.enable_size_variants;
    if (enableVariants) {
      const variantsState = getDefaultVariantsState(productData);
      setVariants(variantsState);
    }

    if (productData?.preselect_warranty && productData?.add_warranty_for_product) {
      setWarrantyState(true);
    }

    const defaultProduct =
      defaultProductIndex !== -1 ? productData.products[defaultProductIndex] : productData.products[0];

    if (defaultProduct) handleChange(defaultProduct);
  }, [productData.products, isSubscribe]);
};
